import { Box, Flex, Image, Text, useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import OtpForm from '../features/authentication/OtpForm';
import { useGetAuthOtp } from '../apis/auth';
import { encryptData } from '../utils/encryptJson';
import { useAppSelector } from '../app/hooks';
import jwtDecode from 'jwt-decode';
import { decryptJson } from '../utils/decryptJson';
import SetSecurityQuestions from '../features/securityQuestion/SetSecurityQuestions';
import customToast, { ToastType } from '../components_/Toast';
import { arrowLeft } from '../assets/images/login';
import { Colors } from '../utils/constants';
import Typography from '../components_/Typography';

const LoggedInUserSecurity = () => {
  const token: any = localStorage.getItem('login-token');
  const details: any = jwtDecode(token);
  const { mutate: getAuthOtp } = useGetAuthOtp();
  const [step, setStep] = useState(1);
  const [isMobile] = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    getAuthOtp(encryptData({ email: details?.email }));
  }, []);
  const handleSuccess = (response: any) => {
    const res = decryptJson(response?.data);
    localStorage.setItem('login-token', res?.token);
    localStorage.setItem('paymentToken', res?.token);
    localStorage.setItem('login-email', res?.email);
    localStorage.setItem('login-phone', res?.phoneNumber);
    localStorage.setItem('sessId', res?.sessId ?? '');
    localStorage.setItem('2fa-enabled', res?.is2FAEnabled);
    customToast('Email verified successfully', ToastType.success);
    setStep(2);
  };
  return (
    <Flex direction={'column'} alignItems={'center'} pt={'50px'}>
      {step === 1 ? (
        <Box maxW={'600px'} width={'90%'}>
          <Text
            fontSize={isMobile ? '20px' : '24px'}
            fontWeight={600}
            fontFamily={'Poppins'}
            lineHeight={'36px'}
            mb={'24px'}
          >
            Reset Security Question
          </Text>
          <Box
            border={`1px solid #D4D9E0`}
            padding={isMobile ? '0px' : '20px'}
            borderRadius={'8px'}
          >
            <OtpForm
              hasBack={false}
              userEmail={details?.email}
              loginToken={token}
              handleSuccess={handleSuccess}
            />
          </Box>
        </Box>
      ) : (
        <>
          <Flex
            alignItems={'center'}
            gap={'8px'}
            cursor={'pointer'}
            onClick={() => setStep(1)}
            maxW={'600px'}
            width={'90%'}
            justifyContent={'flex-start'}
            mb={'10px'}
          >
            <Image src={arrowLeft} boxSize={{ base: '1rem', md: '1.5rem' }} />
            <Typography color={Colors.green} fontSize={'0.7rem'} fontWeight={500}>
              Back
            </Typography>
          </Flex>
          <Box
            maxW={'600px'}
            width={'100%'}
            border={`1px solid #D4D9E0`}
            px={isMobile ? '30px' : '40px'}
            borderRadius={'8px'}
          >
            <SetSecurityQuestions userEmail={details?.email} loginToken={token} hasBack={false} />
          </Box>
        </>
      )}
    </Flex>
  );
};

export default LoggedInUserSecurity;
